import { FILTER_OPERATIONS_MAP } from 'constants/filterOperations';

export enum ANALYTIC_FILTER_OPERATIONS {
  EQUAL = 'EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  IN = 'IN',
  LESS_THAN = 'LESS_THAN',
  LIKE = 'LIKE',
  NOT_EQUAL = 'NOT_EQUAL',
  NOT_IN = 'NOT_IN',
  NOT_LIKE = 'NOT_LIKE',
}

export const ANALYTIC_FILTRATION_ICONS = {
  [ANALYTIC_FILTER_OPERATIONS.EQUAL]: <FILTER_OPERATIONS_MAP.Equals />,
  [ANALYTIC_FILTER_OPERATIONS.GREATER_THAN]: <FILTER_OPERATIONS_MAP.More />,
  [ANALYTIC_FILTER_OPERATIONS.IN]: <FILTER_OPERATIONS_MAP.In />,
  [ANALYTIC_FILTER_OPERATIONS.LESS_THAN]: <FILTER_OPERATIONS_MAP.Less />,
  [ANALYTIC_FILTER_OPERATIONS.LIKE]: <FILTER_OPERATIONS_MAP.Contains />,
  [ANALYTIC_FILTER_OPERATIONS.NOT_EQUAL]: <FILTER_OPERATIONS_MAP.NotEquals />,
  [ANALYTIC_FILTER_OPERATIONS.NOT_IN]: <FILTER_OPERATIONS_MAP.NotIn />,
  [ANALYTIC_FILTER_OPERATIONS.NOT_LIKE]: <FILTER_OPERATIONS_MAP.NotContains />,
};
